'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.eqCheck = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.memoize = memoize;

var _every = require('lodash/every');

var _every2 = _interopRequireDefault(_every);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
var eqCheck = exports.eqCheck = defaultEqualityCheck;

var argsAreEqual = function argsAreEqual(lastArgs, nextArgs, equalityCheck) {
    return nextArgs.every(function (arg, index) {
        return equalityCheck(arg, lastArgs[index]);
    });
};

var rowsAreEqual = function rowsAreEqual(ids, rowsA, rowsB) {
    return ids.every(function (id) {
        return rowsA[id] === rowsB[id];
    });
};

var tablesAreEqual = function tablesAreEqual(rowsA, rowsB) {
    var rowIdsA = (0, _keys2.default)(rowsA);
    var rowIdsB = (0, _keys2.default)(rowsB);

    if (rowIdsA.length !== rowIdsB.length) {
        return false;
    }

    return rowsAreEqual(rowIdsA, rowsA, rowsB) && rowsAreEqual(rowIdsB, rowsA, rowsB);
};

var accessedModelInstancesAreEqual = function accessedModelInstancesAreEqual(previous, ormState) {
    var accessedModelInstances = previous.accessedModelInstances;


    return (0, _every2.default)(accessedModelInstances, function (accessedInstances, modelName) {
        var previousRows = previous.ormState[modelName].itemsById;
        var rows = ormState[modelName].itemsById;


        var accessedIds = (0, _keys2.default)(accessedInstances);
        return rowsAreEqual(accessedIds, previousRows, rows);
    });
};

var fullTableScannedModelsAreEqual = function fullTableScannedModelsAreEqual(previous, ormState) {
    var fullTableScannedModels = previous.fullTableScannedModels;


    return fullTableScannedModels.every(function (modelName) {
        var previousRows = previous.ormState[modelName].itemsById;
        var rows = ormState[modelName].itemsById;

        return tablesAreEqual(previousRows, rows);
    });
};

function memoize(func) {
    var argEqualityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
    var orm = arguments[2];

    var previous = {
        result: null,

        args: null,

        ormState: null,

        fullTableScannedModels: [],

        accessedModelInstances: {}
    };

    return function () {
        for (var _len = arguments.length, stateAndArgs = Array(_len), _key = 0; _key < _len; _key++) {
            stateAndArgs[_key] = arguments[_key];
        }

        var ormState = stateAndArgs[0],
            args = stateAndArgs.slice(1);


        var selectorWasCalledBefore = previous.args && previous.ormState;

        if (selectorWasCalledBefore && argsAreEqual(previous.args, args, argEqualityCheck) && accessedModelInstancesAreEqual(previous, ormState) && fullTableScannedModelsAreEqual(previous, ormState)) {
            return previous.result;
        }

        previous.args = args;

        var session = orm.session(ormState);
        previous.ormState = ormState;

        var result = func.apply(undefined, [session].concat((0, _toConsumableArray3.default)(args)));
        previous.result = result;

        previous.accessedModelInstances = session.accessedModelInstances;

        previous.fullTableScannedModels = session.fullTableScannedModels;

        return result;
    };
}